import CriteriaPanelistsPage from "@Evaluation/CriteriaSurveys/Pages/CriteriaPanelistsPage.vue";
import MeetingManagerPage from "@Evaluation/CriteriaSurveys/Pages/MeetingManagerPage.vue";
import PanelistMeetingPage from "@Evaluation/CriteriaSurveys/Pages/PanelistMeetingPage.vue";
import PanelistSurveyCriterionPage from "@Evaluation/CriteriaSurveys/Pages/PanelistSurveyCriterionPage.vue";
import PanelistSurveyDashboardPage from "@Evaluation/CriteriaSurveys/Pages/PanelistSurveyDashboardPage.vue";


export const routes = [
    {
        path: "/portfolio/criteria-panelists/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: CriteriaPanelistsPage,
    },
    {
        path: "/decision/criteria-panelists/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: CriteriaPanelistsPage,
    },

    {
        path: "/portfolio/criteria-review/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: MeetingManagerPage,
    },
    {
        path: "/decision/criteria-review/:workspaceId/:projectId/:evalModelId/:surveyId",
        component: MeetingManagerPage,
    },


    {
        path: "/weighting/dashboard/:workspaceId/:surveyId/:projectUserId",
        component: PanelistSurveyDashboardPage,
    },
    {
        path: "/weighting/context/:workspaceId/:surveyId/:projectUserId/:criterionId",
        component: PanelistSurveyCriterionPage,
    },
    {
        path: "/weighting/meeting/:workspaceId/:surveyId/:projectUserId",
        component: PanelistMeetingPage,
    },
]
